// extracted by mini-css-extract-plugin
export default {"form":"miniSearch_form__oFUZv","wrapper":"miniSearch_wrapper__sP43C","result":"miniSearch_result__0KBro","split":"miniSearch_split__KU8wv"};